export const MEETING_MODE = {
    NORMAL: 0,
    PRIVATE: 1
}

export const CAMERA = {
    ON: 0,
    OFF: 1
}

export const MICROPHONE = {
    ON: 0,
    OFF: 1
}

export const MESSAGE = {
    ON: 0,
    OFF: 1
}

export const SHARING_FILE = {
    ON: 0,
    OFF: 1
}

export const POLL = {
    EVERYONE: 0,
    HOST_AND_COHOST: 1
}

export const SHARING_SCREEN = {
    ON: 0,
    OFF: 1
}

export const WHITEBOARD = {
    ON: 0,
    OFF: 1
}

export const HAND_UP = {
    ON: 0,
    OFF: 1
}

export const CHANGE_NAME = {
    ON: 0,
    OFF: 1
}

export const RECORD = {
    ON: 0,
    OFF: 1
}

export const NUMBER_PARTICIPANTS_IN_ONE_ROOM = {
    MAX: 100,
    OWNER: 1,
};

export const maxDateTime= {
    dateMax: '2050-12-31T16:59:00.000Z'
}

export const minDateTime= {
    dateMin: '2020-12-31T16:59:00.000Z'
}

export const daily = {
    min: 1,
    max: 31,
};

export const weekly = {
    min: 1,
    max: 13,
};

export const monthly = {
    min: 1,
    max: 12,
};

